import React from 'react'
import { links, constants, fbq, mixpanel, snowplow } from 'common/helpers'

import WidthContainer from 'components/_new/layout/widthContainer/WidthContainer/WidthContainer'
import Button from 'components/_new/Button/Button'
import Logo from 'components/ui/Logo/Logo'
import Link from 'components/ui/Link/Link'

import messages from './messages'
import s from './ExceptMobile.scss'


const HeaderExceptMobile = () => {
  const handleLinkClick = () => {
    mixpanel.track(constants.analyticsEvents.mainPageLoginClick)
  }

  const handleButtonClick = () => {
    snowplow.track(constants.snowplowEvents.getStarted, { position: 1, placement: 'header' })
    fbq.trackCustom('GetStarted')
  }

  return (
    <div className={s.header}>
      <WidthContainer className={s.container} dataTestId={constants.testIds.layout.header}>
        <Logo dark />
        <div className={s.nav}>
          <Link
            className={s.item}
            title={messages.logIn}
            to={links.login}
            customColor
            onClick={handleLinkClick}
          />
          <Button
            className={s.button}
            title={messages.buttonTitle}
            size="md"
            color="brandBorder"
            noPadding
            to={links.pick}
            onClick={handleButtonClick}
          />
        </div>
      </WidthContainer>
    </div>
  )
}


export default HeaderExceptMobile
